export default "__VITE_ASSET__c2748dc5__"